// Packages
import { createAsyncThunk } from '@reduxjs/toolkit';
// API
import { IncidentsAPI } from 'api/endpoints';
// Interfaces and types
import {
  IGetIncidentsRes,
  IGetIncidentDetailsRes,
  IUpdateIncidentsBodyWithParams,
  IUpdateIncidentsRes,
  IDeleteIncidentsParams,
  IDeleteIncidentsRes,
} from 'types/incidentTypes';
import { IErrorRes, TQueryParams } from 'types/appTypes';

const getIncidentsAsync = createAsyncThunk<
  IGetIncidentsRes,
  TQueryParams,
  { rejectValue: IErrorRes }
>('incidents/getIncidents', async (params: TQueryParams, { rejectWithValue }) => {
  try {
    return await IncidentsAPI.getIncidents(params);
  } catch (error) {
    return rejectWithValue(error as IErrorRes);
  }
});

const getIncidentDetailsAsync = createAsyncThunk<
  IGetIncidentDetailsRes,
  number,
  { rejectValue: IErrorRes }
>('incidents/getIncidentDetails', async (params: number, { rejectWithValue }) => {
  try {
    return await IncidentsAPI.getIncidentDetails(params);
  } catch (error) {
    return rejectWithValue(error as IErrorRes);
  }
});

const updateIncidentAsync = createAsyncThunk<
  IUpdateIncidentsRes,
  IUpdateIncidentsBodyWithParams,
  { rejectValue: IErrorRes }
>(
  'incidents/updateIncident',
  async (cred: IUpdateIncidentsBodyWithParams, { rejectWithValue }) => {
    try {
      return await IncidentsAPI.updateIncidentsDetails(cred);
    } catch (error) {
      return rejectWithValue(error as IErrorRes);
    }
  },
);

const deleteIncidentAsync = createAsyncThunk<
  IDeleteIncidentsRes,
  IDeleteIncidentsParams,
  { rejectValue: IErrorRes }
>('incidents/deleteIncident', async (params: IDeleteIncidentsParams, { rejectWithValue }) => {
  try {
    return await IncidentsAPI.deleteIncidentsDetails(params);
  } catch (error) {
    return rejectWithValue(error as IErrorRes);
  }
});

export {
  getIncidentsAsync,
  getIncidentDetailsAsync,
  updateIncidentAsync,
  deleteIncidentAsync,
};
